import { EPickupInStoreStatus } from '@common/enums';
import { SalesOrder } from './order.model';
import { SuperModel } from './super-model.model';

export class PickupInStoreOrder extends SuperModel {
  orderNumber: string;
  clickAndCollectStore: any;
  status: EPickupInStoreStatus;
  receivedInStoreAt: Date | string;
  pickedAt: Date | string;
  movedToBeReturnedAt: Date | string;
  returnedBackToWarehouseAt: Date | string;
  verificationCustomerCode: string;
  order: SalesOrder;
  creationDate: Date;
  customerFullName: string;

  constructor(data: any = {}) {
    super(data);
    if (data.order) {
      this.order = new SalesOrder(data.order);
    }
  }

  get serialised() {
    return {};
  }
}
